export const testImage = (url) => {
  return new Promise((resolve, reject) => {
    var image = new Image();
    image.addEventListener("load", resolve);
    image.addEventListener("error", reject);
    image.src = url;
  });
};
